import React, { useContext, useEffect } from 'react';

import { network, projectId } from '../config';
import { ManifoldContext } from '../Provider';

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/connect-widget
export const Connect = ({ className }: { className?: string }) => {
  const { init } = useContext(ManifoldContext);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <div
      className={className}
      data-always-open="true"
      data-auto-reconnect="false"
      data-delay-auth="true"
      data-enable-network-switching="true"
      data-multi="true"
      data-network={network}
      data-show-balance="false"
      data-wallet-connect-project-id={projectId}
      data-widget="m-connect"
      id="connect-widget"
    />
  );
};
